/**
 * created by tian ruo jun
 link
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";

export default class Link extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            hideBtn: props.hideBtn
        }
    }

    show (){
        this.setState({hideBtn:false});
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            this.state.hideBtn ? "" :
            <Button
                type={"link"}
                style={{margin: "0 12px"}}
                onClick={this.props.onClick}
            >
                {this.props.icon}
                {this.props.btnName}
            </Button>
        )
    }

}